export default {
  coverImage: 'https://i.pinimg.com/originals/5e/66/18/5e6618a423dbc370f695a947842724ef.jpg',
  profileImage: 'images/redhat.jpg',
  fullName: 'Massimo Schembri',
  profession: '{Devops, Infrastructure, Platform} Engineer',
  cv: {
    url: './CV.pdf',
    icon: 'mdi-download'
  },
  email: {
    address: 'massimo.schembri18@gmail.com',
    icon: 'mdi-email-send'
  },
  links: [
    {
      title: 'Github',
      url: 'https://github.com/peterparser',
      icon: 'mdi-github'
    },
    {
      title: 'Linkedin',
      url: 'https://www.linkedin.com/in/massimoschembri/',
      icon: 'mdi-linkedin'
    },
    {
      title: 'Credly',
      url: 'https://www.credly.com/users/massimo-schembri',
      icon: 'mdi-certificate'
    }

  ]
};
